import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController, Platform } from "ionic-angular";
import { Observable } from "rxjs";
import * as moment from "moment";

import { BackgroundMode } from "@ionic-native/background-mode";
import { Insomnia } from "@ionic-native/insomnia";
import { LocalNotifications } from "@ionic-native/local-notifications";
import { NativeAudio } from "@ionic-native/native-audio";

import { ActuatorService } from "../api/actuator.service";
import { DeviceService } from "../device/device.service";
import { Settings } from "../settings/settings";
import { ApiNew } from "../api/api-new";

@Injectable()
export class DoorBellProvider {
  private activeDoorBell: any;
  private modalInstance: any;
  private timming$: any;
  private openedModal: boolean = false;
  private backgroundWasActive: boolean = false;
  private rigningId: number = null;

  private doorbellRingingText: string;
  private doorbellTimeText: string;

  constructor(
    private actuatorService: ActuatorService,
    private backgroundMode: BackgroundMode,
    private deviceService: DeviceService,
    private insomnia: Insomnia,
    private localNotifications: LocalNotifications,
    private modalCtrl: ModalController,
    private nativeAudio: NativeAudio,
    private translate: TranslateService,
    public platform: Platform,
    public settings: Settings,
    private apiNew: ApiNew
  ) {
    this.modalInstance = this.modalCtrl.create(
      "DeviceDoorBellPage",
      undefined,
      { cssClass: "modal-fullscreen" }
    );
  }

  activateDoorBell(measure: any = null) {
    if (!this.openedModal) {
      if (measure) {
        this.activeDoorBell = {
          device: measure.device,
          endpoint: measure.endpoint,
        };
      }
      if (this.timming$) {
        this.timming$.unsubscribe();
      }
      if (!this.checkDisturbMode()) {
        //No Disturb mode desactivado
        this.openNotification();
        this.showRingingNotification();

        this.timming$ = Observable.timer(7 * 1000).subscribe(() => {
          if (this.openedModal) {
            this.closeNotification();
          }
        });
      } else {
        //No Disturb mode activado
        //this.sendNotification();
        this.setOffDevice();
      }
    }
  }

  storeDoorBellTopic() {
    this.apiNew
      .getAll("devices", { include: "room", limit: 100 })
      .subscribe((values: any) => {
        console.log('values', values);
        const doorBell = values.docs.find((item) => ["000021", "000020", "000022"].includes(item.uid.code));
        this.settings.updateDoorbellTopic(
          "gozmart/sonoff/" + doorBell.uid.mac + doorBell.uid.code + "/relay/0"
        );
      });
  }

  private checkDisturbMode() {
    const noDisturb = localStorage.getItem("noDisturb");
    if (noDisturb === "true") {
      return true;
    }
    return false;
  }

  private openNotification() {
    this.modalInstance.onDidDismiss((action) => {
      if (this.timming$) {
        this.timming$.unsubscribe();
      }
      this.openedModal = false;

      this.stopAudio();
      this.removeRingingNotification();
      if (!action) {
        //this.sendNotification();
        this.backgroundAgain();
      }
      this.sleepAgain();
      this.setOffDevice();
    });
    this.modalInstance.present();

    this.nativeAudio.loop(this.settings.getDoorbellTone());
    if (this.platform.is("cordova")) {
      // Simulate we are in background in order to send to dasnboard of mobilock
      this.backgroundWasActive = true;

      if (this.backgroundMode.isActive()) {
        this.showRingingNotification();
      }
      this.backgroundMode.unlock();
      this.backgroundMode.wakeUp();
      this.backgroundMode.moveToForeground();
    }
    this.openedModal = true;
  }

  private backgroundAgain() {
    if (this.backgroundWasActive) {
      this.backgroundWasActive = false;

      if (this.platform.is("cordova")) {
        this.backgroundMode.moveToBackground();
      }
    }
  }

  private sleepAgain() {
    if (this.platform.is("cordova")) {
      this.insomnia.allowSleepAgain().then(
        () => console.log("allowSleepAgain success"),
        () => console.log("allowSleepAgain error")
      );
    }
  }

  private closeNotification() {
    this.modalInstance.dismiss(false).catch(() => {});
  }

  private stopAudio() {
    this.nativeAudio.stop(this.settings.getDoorbellTone());
  }

  private sendNotification() {
    if (this.deviceService.isWallTablet()) {
      return;
    }
    this.translate.get("DOORBELL_RINGING_TIME").subscribe((value) => {
      this.doorbellTimeText = value;

      this.localNotifications.schedule({
        id: moment().unix(),
        text: this.doorbellTimeText + " " + moment().format("HH:mm:ss"),
        sound: null,
        icon: "res://icon",
        smallIcon: "res://doorbell",
      });
    });
  }

  private showRingingNotification() {
    if (this.deviceService.isWallTablet()) {
      return;
    }
    this.translate.get("DOORBELL_RINGING").subscribe((value) => {
      this.doorbellRingingText = value;

      this.rigningId = moment().unix();
      this.localNotifications.schedule({
        id: this.rigningId,
        text: this.doorbellRingingText,
        sound: null,
        icon: "res://icon",
        smallIcon: "res://doorbell",
      });
    });
  }

  private removeRingingNotification() {
    if (this.rigningId) {
      this.localNotifications.clear(this.rigningId);
      this.rigningId = null;
    }
  }

  private setOffDevice() {
    if (!this.activeDoorBell) {
      return;
    }
    this.activeDoorBell.value = "Off";
    this.actuatorService.create(this.activeDoorBell).subscribe(
      (res) => {
        this.activeDoorBell = null;
      },
      (err) => {
        this.activeDoorBell = null;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/door-bell/door-bell.ts